import Monitoring from '@/Monitoring';
import EventTracker from '@/utils/EventTracker';
import { create } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';

type School = { id: string; name: string };

interface UserState {
  id: string;
  name: string;
  schools: School[];
  currentSchoolId: string;
  prefer: boolean;
  isFilled: () => boolean;
  reset: () => void;
}

const initialState = {
  id: '',
  name: '',
  picture: '',
  schools: [],
  currentSchoolId: '',
  prefer: false,
};

const useUserStore = create<UserState>()(
  persist(
    subscribeWithSelector((set, get) => ({
      ...initialState,

      isFilled: () => Boolean(get().id),
      reset: () => set({ ...initialState }),
    })),
    { name: 'user_store' },
  ),
);

useUserStore.subscribe(
  (state) => [state.id],
  ([id]) => {
    Monitoring.setConfig({
      uin: id,
    });
    EventTracker.setUser(id);
  },
);

export default useUserStore;
